import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";

function AssignRoles() {
  const token = localStorage.getItem("token");
  // const organizationId = localStorage.getItem("organizationId");
  // let centerId = localStorage.getItem("centerId");

  // if (centerId === "null") {
  //   centerId = 0;
  // }

  const organizationId =
    localStorage.getItem("organizationId") === "null" ||
    localStorage.getItem("organizationId") === "0"
      ? 0
      : localStorage.getItem("organizationId");

  const centerId =
    localStorage.getItem("centerId") === "0" ||
    localStorage.getItem("centerId") === "null"
      ? 0
      : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm();

  const [usersData, setUsersData] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getUsersList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `UserAuthentication/GetUsersByCenterId?organizationId=${organizationId}&centerId=${centerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUsersData(response);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    getUsersList();
  }, [triggerRerender]);

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      omit: true,
      width: "70px",
    },
    {
      name: "Username",
      selector: (row) => row.userName,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <>
          <div className="d-flex gap-1">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm py-1 px-2"
              onClick={() => handleAssignClick(row)}
            >
              Assign Role
            </button>
          </div>
        </>
      ),
    },
  ];

  const handleAssignClick = async (userRow) => {
    setSelectedUser(userRow);
    var formData = { id: userRow.id };
    try {
      const response = await post(
        `UserAuthentication/GetAssignedRoles`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setRolesData(response);
    } catch (error) {
      console.error("Error fetching permission:", error);
    }
  };

  const saveData = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formData = {
      userId: selectedUser.id,
      roles: rolesData.map((role) => ({
        roleId: role.id,
        status: !role.isDeleted,
      })),
    };

    try {
      const response = await post(`UserAuthentication/AssignRoles`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
      }
    } catch (error) {
      console.error("Error saving permission:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Assign Roles to Users</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <DataTable
                columns={columns}
                data={usersData}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          {selectedUser ? (
            <div className="card">
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <p className="mb-3">
                      Assign Role to <strong>{selectedUser.userName}</strong>
                    </p>
                    {rolesData.map((role) => (
                      <div className="form-check" key={role.id}>
                        <label>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={!role.isDeleted}
                            onChange={() => {
                              setRolesData((prevRoles) =>
                                prevRoles.map((r) =>
                                  r.id === role.id
                                    ? { ...r, isDeleted: !r.isDeleted }
                                    : r
                                )
                              );
                            }}
                          />
                          {role.name}
                        </label>
                      </div>
                    ))}
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-primary btn-sm"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Save" : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </form>
    </>
  );
}

export default AssignRoles;
